import React, { memo } from 'react'
import chatStyles from '../../styles/dynamic.scss'

const ChatStyles = ({ variables, cssVars = true }) => (
  <style className="chat-styles">
    {!cssVars
      ? chatStyles.replace(/\$[\w-]+/g, name => variables[name.slice(1).replace(/-\w/g, x => x[1].toUpperCase())])
      : chatStyles.replace(/\$[\w-]+/g, name => `var(--${name.slice(1)})`)
    }
    {cssVars && `.chat-widget, .chat-widget-mobile-thumb {
      ${Object.entries(variables).map(([name, value]) => `--${name.replace(/[A-Z]/g, e => '-' + e.toLowerCase())}: ${value}`).join(';')}
    }`}
  </style>
)

export default memo(ChatStyles)
